import { useTranslation } from "react-i18next"

import { Lock } from "@/components/icons"
import { Card, CardHeader, CardTitle } from "@/components/ui/card"

type LockedManagementSectionProps = {
  icon: React.ReactNode
  /** Omit when the caller already wraps this in an anchor element — an id on both would be a duplicate. */
  id?: string
  title: string
}

/**
 * Rendered instead of a section's real component when a customer-admin
 * preview resolves that section's capability to `available` (delegable, not
 * yet granted). Deliberately does NOT mount the real section — that would
 * fire its data hooks for a card the customer can't actually use yet.
 */
export function LockedManagementSection({ icon, id, title }: LockedManagementSectionProps) {
  const { t } = useTranslation()

  return (
    <Card className="scroll-mt-24 rounded-lg opacity-60 shadow-sm" id={id}>
      <CardHeader className="pb-2">
        <CardTitle className="text-muted-foreground flex items-center gap-2">
          <div className="flex size-5 items-center justify-center">{icon}</div>
          {title}
          <Lock className="ml-auto size-4" />
        </CardTitle>
        <p className="text-muted-foreground text-xs">
          {t("adminDashboard.management.customerPreview.upsellDescription", {
            defaultValue: "Available — ask your platform admin to enable this.",
          })}
        </p>
      </CardHeader>
    </Card>
  )
}
